import roles from '@/constants/roles';
import { TUser } from '@/types/User.types';

/** Roles that may use this app at all. Everyone else belongs on the client app. */
const ALLOWED_ROLES = [roles.memberCare, roles.superAdmin];

export const WRONG_PLATFORM_MESSAGE = 'Wrong platform. Please proceed to app.myomnia.health';

/**
 * Whether this user is allowed on this app, by role alone.
 *
 * Extracted so sign-in and the boot-time session check cannot drift. Sign-in is
 * currently the only place platform membership is enforced, so any second way
 * into an authenticated session — the boot check being the first — has to apply
 * the same rule or it becomes a way around it.
 */
export const isUserAllowedOnThisPlatform = (user: TUser): boolean =>
  ALLOWED_ROLES.some((role) => user.roles.includes(role));
